import React, { useEffect, useState } from "react";
import emptybox from "./../../assets/images/empty-box.png";
import { BsCheck2Circle } from "react-icons/bs";
import { FaRegClock, FaGlobeAsia, FaLongArrowAltLeft } from "react-icons/fa"
import { MdOutlineErrorOutline } from "react-icons/md";
import { RiVipCrownLine } from "react-icons/ri"
import { FiPhoneCall } from "react-icons/fi"

import { useDispatch, useSelector } from "react-redux";
import { markCallbackCompleted } from "../../utils/awsAPI";
import { callbackSliceAction } from "../../store/callbackSlice";
import { Button, Modal, Spinner } from "react-bootstrap";
import { BsXLg } from "react-icons/bs";

const CallbackCancelled = () => {
    const dispatch = useDispatch()
    const agentObj = useSelector((state:any)=>{return state.agentSlice.agentObj})
    const callbackData = useSelector((state:any)=>{return state.callbackSlice.callbackData})
    const counts = useSelector((state:any)=>{return state.callbackSlice.counts})
    const [CallbackCancelled, setCallbackCancelled] = useState<any>([])
    const [filterCancelled, setFilterCancelled] = useState<any>("")
    const [searchPhone, setSearchPhone] = useState<any>("")
    const [searchQueue, setSearchQueue] = useState<any>("")
    const [searchLanguage, setSearchLanguage] = useState<any>("")
    const [callError, setCallError] = useState<any>("")
    const [modalShow, setModalShow] = useState(false);
    const [contactId, setContactId] = useState("");
    const [isDisabled, setIsDisabled] = useState<any>(false)

    useEffect(() => {
        if(callbackData && callbackData.callback_table) {
            let cancelledCallback = callbackData.callback_table.filter((item:any) => item?.CallbackCancelledByCustomer && !item?.AgentCompleted)
            let sortedData:any = [];
            if(cancelledCallback.length > 0) {
                sortedData = cancelledCallback?.slice().sort((a:any, b:any) => {
                    return (a.Timestamp < b.Timestamp) ? -1 : ((a.Timestamp > b.Timestamp) ? 1 : 0)
                });
                setFilterCancelled(sortedData)
            }
            setFilterCancelled(sortedData)
            setCallbackCancelled(sortedData)
        }
    },[callbackData])

    const onConfirm = (contactId:string) => {
        setContactId(contactId)
        setModalShow(true)
    }

    const onDialNumber = (dialNumber: string, index:number) => {
        if (dialNumber !== '') {
            setCallError("")
            const endpoint = connect.Endpoint.byPhoneNumber(dialNumber);
            agentObj.connect(endpoint, {
                success:function() {
                    console.log("outbound call connected")
                },
                failure:function(err:any) {
                    let error = JSON.parse(err)
                    if(error.type === 'BadEndpointException') {
                        setCallError(index)
                    }
                }
            })
        }
    }

    const onMarkCallbackCompleted = async (contactId: string) => {
        setIsDisabled(true)
        let username = agentObj?.getConfiguration()?.username;
        let status = await  markCallbackCompleted(contactId, username)
        if(status) {
            let remaining = CallbackCancelled.filter((item:any) => item.ContactID !== contactId)
            setCallbackCancelled(remaining)
            let existingCount:any = {}
            existingCount.inbox = counts.inbox;
            existingCount.pending = counts.pending;
            existingCount.cancelled = counts.cancelled - 1;
            existingCount.completed = counts.completed + 1;
            dispatch(callbackSliceAction.setCounts(existingCount))
            let updatedAttributes = callbackData.callback_table.map((item:any) => {
                var temp = Object.assign({}, item);
                if(item.ContactID === contactId) {
                    temp.AgentCompleted = Object.assign({}, item.AgentCompleted, username)
                }
                return temp;
            });
            let finalData = Object.assign({}, { 'callback_table':updatedAttributes})
            dispatch(callbackSliceAction.setCallbackData(finalData))
        }
        setIsDisabled(false)
        setModalShow(false)
    }
    const handleClose = () => setModalShow(false);
    
    const onSearchPhone = (event:any) => {
        let inputData =event.target.value;
        let filterData = CallbackCancelled?.filter((item:any) => {
            return item.PhoneNumber.includes(inputData) && item.QueueName.toLowerCase().startsWith(searchQueue) && item.Language.toLowerCase().startsWith(searchLanguage)
        })
        setFilterCancelled(filterData)
        setSearchPhone(inputData)
    }

    const onSearchQueue = (event:any) => {
        let inputData = (event.target.value).toLowerCase();
        let filterData = CallbackCancelled?.filter((item:any) => {
            return item.PhoneNumber.includes(searchPhone) && item.QueueName.toLowerCase().startsWith(inputData) && item.Language.toLowerCase().startsWith(searchLanguage)
        })
        setFilterCancelled(filterData)
        setSearchQueue(inputData)
    }

    const onSearchLanguage = (event:any) => {
        let inputData = (event.target.value).toLowerCase();
        let filterData = CallbackCancelled?.filter((item:any) => {
            return item.PhoneNumber.includes(searchPhone) && item.QueueName.toLowerCase().startsWith(searchQueue) && item.Language.toLowerCase().startsWith(inputData)
        })
        setFilterCancelled(filterData)
        setSearchLanguage(inputData)
    }

    const onChangeOrder = (event:any) => {
        let order = event.target.value
        const sortedData = filterCancelled?.slice().sort((a:any, b:any) => {
            if(order === 'ASC') {
                return (a.Timestamp < b.Timestamp) ? -1 : ((a.Timestamp > b.Timestamp) ? 1 : 0)
            } else {
                return (a.Timestamp > b.Timestamp) ? -1 : ((a.Timestamp < b.Timestamp) ? 1 : 0)
            }
        });
        setFilterCancelled(sortedData)
    }

    return (
        <React.Fragment>
            <Modal show={modalShow} onHide={handleClose}>
                <Modal.Header >
                    <Modal.Title>Confirmation</Modal.Title>
                    <button className='close-btn-x' onClick={handleClose}>
                        <BsXLg/>
                    </button>
                </Modal.Header>
                <Modal.Body>Are you sure you want to mark as completed?</Modal.Body>
                <Modal.Footer>
                    <Button disabled={isDisabled} variant="primary" onClick={()=>{ onMarkCallbackCompleted(contactId) }}>
                        {isDisabled && <Spinner as="span"animation="grow" size="sm" role="status" aria-hidden="true"/>} Yes
                    </Button>
                    <Button variant="danger" onClick={handleClose}>No</Button>
                </Modal.Footer>
            </Modal>
            <div className="col-12 filter-sticky">
                <div className="col-12 bg-light p-3 mb-3">
                    <div className="row">
                        <label className="mt-2 col-1">Filters:</label>
                        <div className="col-11">
                            <div className="row"> 
                                <div className="col">
                                    <input type="text" onChange={(event)=>{onSearchPhone(event)}} value={searchPhone} className="form-control" placeholder="Phone number" />
                                </div>
                                <div className="col">
                                    <input type="text" onChange={(event)=>{onSearchQueue(event)}} value={searchQueue} className="form-control" placeholder="Queue" />
                                </div>
                                <div className="col">
                                    <input type="text" onChange={(event)=>{onSearchLanguage(event)}} value={searchLanguage} className="form-control" placeholder="Language" />
                                </div>
                                <div className="col">
                                    <select onChange={(event)=>{onChangeOrder(event)}} className="form-select">
                                        <option value="ASC">Ascendent</option>
                                        <option value="DSC">Descendent</option>
                                    </select>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ul className="callback-list d-flex flex-column list-unstyled">
                {filterCancelled && filterCancelled.map((callback:any, index:number) => {
                    return (
                        <li key={index+1}>
                            <div className="d-flex justify-content-between mb-1">
                                <div>
                                    <div className="contact-no me-3"><strong><FiPhoneCall /> Phone number: </strong>{ callback?.PhoneNumber || '-'}</div>
                                    <div className="date-time"><strong><FaRegClock /> Date & time:</strong> {(callback?.Timestamp) ? new Date(callback?.Timestamp).toLocaleString() : '-'}</div>
                                    <div className="language"><strong><FaGlobeAsia /> Language:</strong> {callback?.Language || '-'}</div>
                                    <div className=""><strong><FaLongArrowAltLeft /> Queue:</strong> {callback?.QueueName || '-'}</div>
                                    <div className=""><strong><RiVipCrownLine /> Service type:</strong> {callback?.ServiceType || '-'}</div>
                                </div>
                                <div>
                                {(callError && callError === index+1) && <div className='error-text text-danger text-center'><MdOutlineErrorOutline /> Invalid phone number </div>}
                                    <div onClick={() => { onDialNumber(callback?.PhoneNumber, index+1) }} className="mb-1"><button className="btn btn-success"><FiPhoneCall /> Dail number</button></div>
                                    <div onClick={() => { onConfirm(callback.ContactID) }} className="mb-1"><button className="btn btn-primary"><BsCheck2Circle /><span style={{fontSize: "14px"}}> Mark as completed</span></button></div>
                                </div>
                            </div>
                        </li>
                    )
                })}                                                       
            </ul>
            {filterCancelled.length <= 0 &&
                <div className='empty-data'>
                    <img className='empty-icon' src={emptybox} alt="empty box icon" />
                    <h4>No data available</h4>
                </div>
            }
        </React.Fragment>
    )
}
export default CallbackCancelled;
